import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import "./css/futuredecentralised.css"; // Ensure this CSS file exists and the classes are correct

export default function FutureDecentralised() {
  const navigate = useNavigate();

  const infiApplicationForm = () => {
    navigate(`${config.baseUrl}infiListingForm`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="infiLaunchpad position-relative pb-0">
        <Container className="py-5 position-relative z-2">
          <Row className="justify-content-center align-items-center">
            <Col lg={12}>
              <Card className="bg-transparent border-0">
                <Card.Body>
                  <div className="position-relative mb-5">
                    <Row className="justify-content-center">
                      <Col lg={10} className="mb-5">
                        <div className="position-relative d-inline-block text-center">

                          <h1 className=" position-relative text-white lh-sm mb-4">
                            <span className="position-relative z-1">
                              INFI Blockchain
                              <span className="fw-normal">
                                - The Future of Decentralised Innovation
                              </span>
                            </span>
                            <div
                              className="polygon"
                              style={{ right: "-80px" }}
                            >
                              <img
                                src="images/shape/polygon.png"
                                alt=""
                                style={{ width: "208px" }}
                              />
                            </div>
                          </h1>
                          <p className="text-light-grey2 position-relative">
                            INFI Blockchain is a scalable, secure, and high-performance network designed to power
                            the next generation of decentralised applications and digital ecosystems.
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <div className="cardStyle4">
                      <Card className="cardBox border-0">
                        <Card.Body className="p-5">
                          <div className="d-sm-flex  gap-5 align-items-center">
                            <div className="mb-4">
                              <h1 className="text-white">Key Features</h1>
                            </div>
                            <div className="mb-4">
                              <ul className="list-unstyled">
                                <li className="text-light-grey2 mb-2">
                                  <span className="fw-bold text-white">
                                    ✅ High-Speed Processing{" "}
                                  </span>
                                  – Enables fast on-chain actions with minimal network fees.
                                </li>
                                <li className="text-light-grey2 mb-2">
                                  <span className="fw-bold text-white">
                                    ✅ System Connectivity{" "}
                                  </span>
                                  – Bridges legacy digital systems with blockchain
                                  infrastructure.
                                </li>
                                <li className="text-light-grey2 mb-2">
                                  <span className="fw-bold text-white">
                                    ✅ Multi-Chain Compatibility{" "}
                                  </span>
                                  – Supports interoperability across multiple blockchain
                                  environments.
                                </li>
                                <li className="text-light-grey2 mb-2">
                                  <span className="fw-bold text-white">
                                    ✅ Green & Scalable{" "}
                                  </span>
                                  – Utilises energy-efficient consensus for long-term sustainability.
                                </li>
                                <li className="text-light-grey2 mb-2">
                                  <span className="fw-bold text-white">
                                    ✅ Adaptable Architecture{" "}
                                  </span>
                                  – Built to support diverse digital use cases, partner
integrations, and distributed tools.
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className=" position-absolute bottom-0 start-0">
                            <img
                              src="images/shape/deepak.png"
                              width={`140px`}
                              alt=""
                            />
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <div className="bg-waveshape">
          <img src="images/bg-wave.png" alt="" />
        </div>
      </section>
    </>
  );
}
